export default __webpack_public_path__ + "static/media/nothing-found.f6067789.webp";